<div
  class="principal-card"
  (click)="principalClicked()"
  [class.selected]="selected"
>
  <div class="avatar">
    <img [src]="principal.image_url" appFallbackImage />
  </div>
  <div class="info">
    <div
      class="name"
      [innerHTML]="principal.name | highlight: highlightText"
    ></div>
    <div
      class="email"
      [innerHTML]="principal.email | highlight: highlightText"
    ></div>
  </div>
  @if (showDelete) {
    <div class="remove">
      <sui-button
        variant="secondary"
        size="sm"
        [leadingIcon]="['fas', 'times']"
        [iconOnly]="true"
        ariaLabel="Remove"
        (click)="deletePrincipal()"
      ></sui-button>
    </div>
  }
</div>
